import React from 'react';
import { observer } from 'mobx-react';

import { Field } from 'libs/forms/views/field';
import { Validation as ValidationComponent } from 'libs/forms/views/validation';
import { InputWrapper, ResetIcon } from 'libs/forms/styles';
import { StringFieldStore } from 'libs/forms/fieldStores';
import { SingleDatepicker } from 'components/Datepicker';
import { HStack } from '@chakra-ui/react';

@observer
export class DateField extends Field {
  static defaultStore = StringFieldStore;

  onFocus = e => {
    e.target.selectionStart = this.cursor;
  };

  render() {
    const { fieldStore, editComponent, noValidation, responsive } = this.props;
    const Tag = editComponent || InputWrapper;

    return (
      <Tag focussed={fieldStore.isFocussed} responsive={responsive}>
        <HStack>
          <SingleDatepicker
            colorScheme='blue'
            name='date-input'
            date={fieldStore.value}
            isInvalid={!fieldStore.validity[0]}
            onDateChange={date => fieldStore.UpdateValue(date)}
            // applying={filter.applying} -- equivalent to fieldStore.preparing/submitting?
            touched={fieldStore.touched} // quick hack - perhaps we should implement 'touched' into the form framework
            SetTouched={() => {
              fieldStore.touched = true;
            }}
            h='auto'
            px='0'
            borderRadius='0'
            borderWidth='0'
            focusStyles={{ boxShadow: 'none', borderColor: '#fff' }}
            errorBorderColor='transparent'
            /* const DefaultConfigs = {
            dateFormat: 'yyyy-MM-dd',
            monthNames: MonthNamesShort,
            dayNames: WeekdayNamesShort,
            };    */
          />
          {fieldStore.value && (
            <ResetIcon
              name='close_small'
              onMouseDown={e => {
                e.stopPropagation();
              }}
              style={{ opacity: 1 }}
              onClick={fieldStore.ResetValue}
            />
          )}
          {!noValidation && !fieldStore.validity[0] && (
            <ValidationComponent
              fieldStore={fieldStore}
              handleClick={this.focusAfterDelete}
            />
          )}
        </HStack>
      </Tag>
    );
  }
}
